<template>
<section>
  <div class="support-sidebox-container" v-if="showSupportChat && myInscriptions && myInscriptions.length">
    <div class="support-sidebox-header">
      <el-button type="primary" size="mini" @click="openSupportTicket" v-if="!isThereOngoingSupport">Iniciar novo suporte</el-button>
      <i class="fas fa-times auto-left" @click.capture="toggleSupportChat"></i>
    </div>
    <div class="support-sidebox-scroller">
      <div class="support-sidebox-item" v-for="item,n in myInscriptions" :key="item.inscript_user_id">
        <div class="support-sidebox-item-content" @click="showChatHandler(item)">
          <ion-icon class="support-chat-icon" name="chatbubbles-outline"></ion-icon>
          <p>{{item.code_inscript}}</p>
          <el-tag size="mini" type="danger" v-if="item.status === 1">{{statusCodes[item.status]}}</el-tag>
          <el-tag size="mini" type="warning" v-if="item.status === 2">{{statusCodes[item.status]}}</el-tag>
          <el-tag size="mini" type="success" v-if="item.status === 3">{{statusCodes[item.status]}}</el-tag>
          <el-tag size="mini" type="info" v-if="item.status === 4">{{statusCodes[item.status]}}</el-tag>
          <el-tag size="mini" type="info" v-if="item.status === 5">{{statusCodes[item.status]}}</el-tag>
          <i class="fas fa-caret-up auto-left" v-if="item.showChat"></i>
          <i class="fas fa-caret-down auto-left" v-else></i>
        </div>
        <Sidebox :isSupport="true" class="support-sidebox-chat" :channel="item.inscript_user_id" :refHeight="400" v-if="item.showChat"/>
      </div>
    </div>
  </div>
  <div class="support-sidebox-container support-initial-container" v-if="showSupportChat && (!myInscriptions || myInscriptions.length === 0)">
    <i class="fas fa-times support-initial-close-btn" @click="showSupportChat=!showSupportChat"></i>
    <p>Olá, {{this.$store.state.user.nickname ? this.$store.state.user.nickname : this.$store.state.user.name}}!</p>
    <p v-html="supportConfig.texts.initialPrompt"></p>
    <el-button type="primary" size="mini" @click="openSupportTicket">Iniciar suporte</el-button>
  </div>
</section>
</template>

<script>
import api from '@/services/api.js';
import Sidebox from '@/components/chat_qa_box/Sidebox.vue';

export default {
  name: 'UserSupportBox',

  components: {
    Sidebox
  },

  data() {
    return {
      showSupportChat: false,
      myInscriptions: null,
      statusCodes: {
        0: "Não alocado",
        1: "Suporte solicitado",
        2: "Em atendimento",
        3: "Resolvido",
        4: "Cancelado",
        5: "Inativo"
      },
      supportConfig: {
        texts: {
          initialPrompt: "Está precisando de ajuda?<br> Abra um ticket de suporte clicando no botão abaixo e nos descreva o problema no chat.",
          openSupportTicket: "Sua solicitação de suporte foi enviada com sucesso. Descreva seu problema neste chat.",
          callUser: "Sua solicitação de suporte está em atendimento.",
          closeTicketSuccess: "Sua solicitação de suporte foi finalizada com sucesso.",
          closeTicketCanceled: "Sua solicitação de suporte foi cancelada.",
          closeTicketNoshow: "Sua solicitação de suporte foi finalizada por inatividade."
        },
        genericTeam: {
          name: "Equipe de suporte",
          image: "https://blitzar-assets.s3.amazonaws.com/imgs/support_icon.jpg",
        },
      },
      supportActivity: null,
      userProfile: null,
    }
  },

  computed: {
    isThereOngoingSupport() {
      if (this.myInscriptions && this.myInscriptions.length) {
        const ongoingSupport = this.myInscriptions.filter(item => [1, 2].includes(item.status));
        return ongoingSupport.length > 0;
      }
      return false;
    }
  },

  methods: {
    async getSupportInscriptionActivities() {
      try {
        const response = await api.get(`/event/${this.$store.state.eventId}/inscripts`);
        const supportActivities = response.data.filter(item => item.inscription === true && item.category === 'support');
        this.supportActivity = supportActivities[0];
      } catch (error) {
        console.error(error);
      }
    },
    getMyInscriptions() {
      api.get(`/event/${this.$store.state.eventId}/myinscripts`)
        .then(response => {
          this.myInscriptions = response.data.filter(item => item.activity.includes('Suporte'));
          this.myInscriptions = this.myInscriptions.map(item => {
            item.showChat = false;
            return item;
          });
          if (this.myInscriptions && this.myInscriptions.length) this.myInscriptions[0].showChat = true;
        })
        .catch(error => {
          console.error(error);
        });
    },
    openSupportTicket() {
      api.post(`activity/${this.supportActivity.activity_id}/inscript`)
        .then(response => {
          this.sendChatMessage(response.data.inscript_user_id, this.supportConfig.texts.openSupportTicket);
          this.getMyInscriptions();
        })
        .catch(err => {
          console.error(err);
        });
    },
    sendChatMessage(channelID, msg) {
      const payload = {
        chat_room_id: channelID,
        message: msg,
        name: this.supportConfig.genericTeam.name,
        image: this.supportConfig.genericTeam.image,
        tags: JSON.stringify({ isAdmin: true }),
      }
      api
        .post(`activity/${channelID}/chat`, payload)
        .catch(err => {
          console.error(err);
        });
    },
    showChatHandler(item) {
      this.myInscriptions = this.myInscriptions.map(inscription => {
        if (inscription.inscript_user_id === item.inscript_user_id) {
          inscription.showChat = !inscription.showChat;
        } else {
          inscription.showChat = false;
        }
        return inscription;
      });
    },
    toggleSupportChat() {
      this.showSupportChat = !this.showSupportChat;
      if (this.showSupportChat) this.getMyInscriptions();
    },
  },

  beforeMount() {
    this.userProfile = this.$store.state.template.userProfile;
    if (this.userProfile.supportChatProvider.active && this.userProfile.supportChatProvider.config) {
      this.supportConfig = this.userProfile.supportChatProvider.config;
      this.getMyInscriptions();
      this.getSupportInscriptionActivities();
    }
  },
  mounted() {
    this.$root.$on('toggleSupportChat', () => {
      this.toggleSupportChat();
    });
  },
}
</script>

<style lang="scss">
// SUPPORT CHAT
.support-sidebox-container {
  position: fixed;
  bottom: 34px;
  right: 10px;
  width: 370px;
  max-height: 500px;
  z-index: 1;
  border-radius: 10px;
  background-color: var(--main-color);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;

  @include media("<=phone") {
    width: 98%;
    right: 0;
    margin: 0 4px;
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;

  .support-sidebox-header {
    position: relative;
    width: 100%;
    height: 48px;
    padding: 10px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-button {
      margin-left: 10px;
    }
  }

  .support-sidebox-scroller {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .support-sidebox-chat {
    width: 100%;
  }

  .support-sidebox-item {
    width: 100%;
    min-height: 48px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    gap: 10px;

    .support-sidebox-item-content {
      position: absolute;
      padding: 10px;
      width: 100%;
      min-width: 370px;
      z-index: 10;
      background: var(--chat-mainColor);
      cursor: pointer;

      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;

      p {
        position: relative;
        margin: 0 20px;
        font-size: 1rem;
        font-weight: bold;
        color: var(--chat-textColor);
      }

      .support-chat-icon {
        position: relative;
        font-size: 1.5rem;
        color: var(--chat-textColor);
      }
    }
  }
}
.support-initial-container {
  position: fixed;
  bottom: 38px;
  right: 10px;
  padding: 20px;
  max-width: 300px;
  border-radius: 10px;
  background-color: var(--main-color);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease-in-out;

  display: flex;
  flex-direction: column;
  gap: 20px;

  .support-initial-close-btn {
    position: absolute;
    top: 4px;
    right: 6px;
    font-size: 1rem;
    color: var(--text-color);
    cursor: pointer;
  }

  p {
    width: 100%;
    font-size: 1rem;
    font-weight: bold;
    color: var(--text-color);
  }

  el-button {
    margin-top: 10px;
  }
}
</style>